import { RefreshCw } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  ListRequest,
  useVbsConfirmationListQuery,
} from "@/services/backend/vbs/confirmations/api/confirmation-api";
import { ReferenceNumber } from "@/services/backend/documents/components/reference-number";
import { ComponentProps } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";
import { DocumentStateBadge } from "@/shared/bsm/core/document/components/ui/document-state-badge";

export function ConfirmationSelect({
  listRequest,
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  listRequest: ListRequest;
}) {
  const { data, isLoading, error } = useVbsConfirmationListQuery(listRequest);

  return (
    <Select {...props}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={t("Auftragsbestätigung auswählen")} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {isLoading && (
            <SelectItem value="loading" disabled>
              <RefreshCw className="size-4" />
              <span>{t("Lade Auftragsbestätigungen")}</span>
            </SelectItem>
          )}
          {error && (
            <SelectItem value="error" disabled>
              <RTKQueryErrorAlert error={error} />
            </SelectItem>
          )}
          {data?.items.length === 0 && (
            <SelectItem value="error" disabled>
              <span>{t("Keine Auftragsbestätigungen")}</span>
            </SelectItem>
          )}
          {data?.items.map((confirmation) => (
            <SelectItem value={confirmation.id} key={confirmation.id}>
              <span className="flex items-center gap-2">
                <ReferenceNumber
                  referenceNumber={confirmation.referenceNumber}
                />
                <DocumentStateBadge document={confirmation} />
              </span>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
